import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import moment from "moment";
import Constants from "../../constants/Common";
import { PermissionAction } from "../../constants/Enums";

import LoggingFilter from "./LoggingPermissionFilter";
import { ExpandedTable, IButton, Layout, StoredPagination } from "../../ui-kit";

import loggingPermissionStore from "../../store/loggingPermission";
import dictionaryStore from "../../store/dictionary";
import Paths from "../../constants/PathsBreadcrumbs";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";

import styles from "./styles.module.scss";

const LoggingPermissions: FC = observer(() => {
  useBreadcrumbs(Paths.adminLoggingPermissions);

  const {
    data,
    getPermissionLogs,
    paginator,
    search,
    sorter,
    filter,
    isLoading,
  } = loggingPermissionStore;

  useEffect(() => {
    getPermissionLogs();
  }, [
    paginator.page,
    paginator.perPage,
    search.search.text,
    sorter.changingKey,
    filter.filterItems,
  ]);

  useEffect(() => {
    dictionaryStore.getDictionaryData("AppModule");
  }, []);

  useEffect(() => {
    const cb = async () => {
      // await dictionaryStore.getDictionaryData("AppModule");
      await getPermissionLogs();
    };
    cb();
  }, []);

  const columns = [
    {
      title: "Дата",
      dataIndex: "created",
      key: "created",
      className: "nowrap",
      render: (created) => {
        return created
          ? moment(created).format(Constants.dateTimeFormat)
          : Constants.notSet;
      },
      sortable: true,
      width: "10%",
    },
    {
      title: "Раздел",
      dataIndex: ["module"],
      key: "appModule",
      sortable: true,
      render: (id, record) => {
        return record.appModule?.title;
      },
      width: "10%",
    },
    {
      title: "Действие",
      key: "description",
      sortable: true,
      render: (_, record) => {
        const permissionAction =
          record.permissionAction >= 0
            ? PermissionAction[record.permissionAction]
            : null;
        const res = permissionAction ?? record.permissionActionString;
        return res;
      },
      width: "10%",
    },
    {
      title: "Система",
      dataIndex: "entityName",
      key: "entityName",
      sortable: true,
      width: "10%",
    },
    {
      title: "Пользователь",
      dataIndex: "userName",
      sortable: true,
      render: (userName) => {
        return userName ? userName : "-";
      },
      width: "15%",
    },
    {
      title: "Организация",
      dataIndex: "organization",
      className: "align-left",
      render: (organization) => {
        return organization ? organization : "-";
      },
      sortable: true,
      width: "20%",
    },
    {
      title: "IP адрес",
      dataIndex: "ipAddress",
      className: "align-left",
      render: (ipAddress) => {
        return ipAddress ? ipAddress : "-";
      },
      sortable: true,
      width: "10%",
    },
    {
      title: "Идентификатор сессии",
      dataIndex: "sessionId",
      className: "align-left",
      render: (sessionId) => {
        return sessionId ? sessionId : "-";
      },
      sortable: true,
      width: "15%",
    },
  ];

  const rowSelection = {
    selectedRowKeys: loggingPermissionStore.selectedRows.keys,
    onChange: (selectedRowKeys) => {
      loggingPermissionStore.selectedRows.setKeys([...selectedRowKeys]);
    },
  };

  return (
    <Layout type="white">
      <div className={styles.Filter}>
        <div className={styles.fields}>
          <LoggingFilter filter={filter} />
        </div>
      </div>
      <ExpandedTable
        loading={isLoading.value}
        columns={columns}
        sort={sorter}
        data={data}
        rowSelection={rowSelection}
      />
      <StoredPagination {...paginator} />

      <IButton
        size="large"
        disabled={
          isLoading.value ||
          loggingPermissionStore.selectedRows.keys.length === 0
        }
        onClick={() => loggingPermissionStore.deletePermissionLogs()}
      >
        Удалить данные
      </IButton>
    </Layout>
  );
});

export default LoggingPermissions;
